import React, { useState, useEffect } from 'react';
import { History, FileText, CheckCircle2, AlertTriangle, RefreshCw } from 'lucide-react';
import { getImportHistory } from '../api/importExport';

export default function ImportHistoryTable() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const data = await getImportHistory();
      setHistory(data || []);
    } catch (err) {
      console.error('Failed to load import history:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="import-history-container glass-panel" style={{ padding: '20px', borderRadius: '14px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <History size={18} color="#0d9488" />
          <h3 style={{ fontSize: '1.05rem', fontWeight: '600' }}>Import History & Audit Log</h3>
        </div>
        <button
          type="button"
          className="btn-secondary btn-sm"
          onClick={fetchHistory}
          disabled={loading}
          title="Refresh history"
        >
          <RefreshCw size={13} className={loading ? 'rotate-anim' : ''} />
          <span>Refresh</span>
        </button>
      </div>

      <p style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', marginBottom: '16px' }}>
        Audit trail of all credential migrations. Per zero-knowledge policy, password values are strictly never retained in history records.
      </p>

      {loading ? (
        <div style={{ padding: '30px', textAlign: 'center', color: 'var(--text-secondary)' }}>
          Loading import logs...
        </div>
      ) : history.length === 0 ? (
        <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>
          No previous imports on this account.
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>DATE</th>
                <th>FILE NAME</th>
                <th>TYPE</th>
                <th>TOTAL ITEMS</th>
                <th>SUCCESSFUL</th>
                <th>FAILED / SKIPPED</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {history.map((record) => (
                <tr key={record.id}>
                  <td>
                    <span style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                      {new Date(record.created_at).toLocaleString()}
                    </span>
                  </td>
                  <td>
                    <strong>{record.file_name}</strong>
                  </td>
                  <td>
                    <span className="file-type-badge">{record.file_type.toUpperCase()}</span>
                  </td>
                  <td>{record.item_count}</td>
                  <td style={{ color: '#10b981', fontWeight: '600' }}>{record.successful_count}</td>
                  <td style={{ color: record.failed_count > 0 ? '#f59e0b' : 'inherit' }}>
                    {record.failed_count}
                  </td>
                  <td>
                    <span
                      className={`status-chip ${
                        record.status === 'completed'
                          ? 'status-chip-active'
                          : record.status === 'failed'
                          ? 'status-chip-danger'
                          : 'status-chip-warning'
                      }`}
                    >
                      {record.status.toUpperCase()}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
